<div class="pagination" *ngIf="data">
    <nav class="Pager1" aria-label="pagination example">
        <ul class="pagination pagination-circle justify-content-center">
            <li class="page-item" [ngClass]="{'active' : link.active == true, 'disabled': link.url == null}"
                *ngFor="let link of data?.links;trackBy:trackByIndex">
                <a class="page-link" href="javascript:void(0)" (click)="changePG(link)"
                    [innerHTML]="link.label"></a>
            </li>
        </ul>
    </nav>
</div>
